import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApplicationsConfiguration } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ScheduledApplicationsResolverActions = createActionGroup({
  source: 'Scheduled applications resolver',
  events: {
    'Scheduled applications requested': emptyProps(),
    'Scheduled applications CSV download requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApplicationsApiActions = createActionGroup({
  source: 'Applications API',
  events: {
    'Scheduled applications loaded': props<{ applications: ApplicationsConfiguration[] }>(),
    'Scheduled applications loaded error': props<{ error: ErrorModel }>(),
    'Scheduled applications CSV downloaded': emptyProps(),
    'Scheduled applications CSV downloaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// EFFECT ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ScheduledApplicationsEffectActions = createActionGroup({
  source: 'Scheduled effects',
  events: {
    'Scheduled applications requested': emptyProps(),
  },
});
